import React from 'react';
//@ts-ignore
import * as styles from './filtered-content.module.css';
import { ContentPreview } from './index';
import { Faq as FaqType } from '../Global/DataUtils/faqQueries';
//@ts-ignore
import Faq from '../Faq';
import { getMultiChoice } from '../Global/DataUtils';
import { KontentRadioMultiChoice } from '../../../types/KontentProps';

interface Props {
    content?: ContentPreview[];
    maxShowInGrid?: number;
    useGrid?: KontentRadioMultiChoice<'grid' | 'stacked'>;
}

const FaqExploration: React.FC<Props> = ({
    content,
    maxShowInGrid,
    useGrid,
}) => {
    const renderContent = (contentItem: FaqType, contentIdx: number) => {
        const gridSpan = maxShowInGrid && contentIdx < maxShowInGrid ? 1 : 3;

        return (
            <Faq
                key={contentIdx}
                faq={contentItem}
                gridSpan={gridSpan}
                truncateBody={gridSpan === 1 ? false : true}
            />
        );
    };
    const faqsLayout = getMultiChoice(useGrid);

    return (
        <div
            className={`${styles.faq} ${
                faqsLayout === 'grid' ? styles.gridfaq : ''
            }`}
        >
            {content &&
                content?.map((contentItem, itemIdx) => {
                    return renderContent(contentItem as FaqType, itemIdx);
                })}
        </div>
    );
};

export default FaqExploration;
